export default __webpack_public_path__ + "static/media/Slide_SaleKit2024-11.d50e52b7.png";